module.exports = __webpack_public_path__ + "static/media/ludeyi.2d3186ef.png";